export enum SourceDomain {
  PflegiaDe = 'pflegia.de',
  PflegiaAt = 'pflegia.at',
  PraxiaDe = 'praxia.de',
  DociaDe = 'docia.de',
}

export const NON_DOCIA_SOURCE_DOMAINS: SourceDomain[] = Object.values(SourceDomain).filter(domain => domain !== SourceDomain.DociaDe);
